export enum ServiceCodeEnum {
  NAME_RESERVATION = 'NAME_RESERVATION',
  COMPANY_REGISTRATION = 'COMPANY_REGISTRATION',
  CLIENT_REGISTRATION = 'CLIENT_REGISTRATION',
  AMEND_COMPANY_NAME = 'AMEND_COMPANY_NAME',
  AMEND_CATEGORY_OF_COMPANY = 'AMEND_CATEGORY_OF_COMPANY',
  AMEND_MEMBER_OF_BOARD_OF_DIRECTORS = 'AMEND_MEMBER_OF_BOARD_OF_DIRECTORS',
  AMEND_BUSINESS_ACTIVITY = 'AMEND_BUSINESS_ACTIVITY',
  TRANSFER_SHARE = 'TRANSFER_SHARE',
  OTHER_AMENDMENTS = 'OTHER_AMENDMENTS',
  ADD_NEW_BRANCH = 'ADD_NEW_BRANCH',
  CLOSING_OF_COMPANY = 'CLOSING_OF_COMPANY',
  DECLARATION_TO_BE_DORMANT = 'DECLARATION_TO_BE_DORMANT',
  AMALGAMATION = 'AMALGAMATION',
  BANK_ACCOUNT_OPENING = 'BANK_ACCOUNT_OPENING',
  AMENDMENT = 'AMENDMENT',
  AMEND_OWNERSHIP = 'AMEND_OWNERSHIP',
  COMPANY_AMENDMENT = 'COMPANY_AMENDMENT',
  CESSATION_OF_DORMANCY = 'CESSATION_OF_DORMANCY',

  // licsense
  LICENSING = 'LICENSING',

  INVESTMENT_BANK_LICENSE = 'INVESTMENT_BANK_LICENSE',
  MERCHANT_BANK_LICENSE = 'MERCHANT_BANK_LICENSE',
  COMMERCIAL_BANK_LICENSE = 'COMMERCIAL_BANK_LICENSE',
  FULL_BANK_LICENSE = 'FULL_BANK_LICENSE',
  MORTGAGE_BANK_LICENSE = 'MORTGAGE_BANK_LICENSE',
  DIGITAL_BANK_LICENSE = 'DIGITAL_BANK_LICENSE',
  REPRESENTATIVE_OFFICE_LICENSE = 'REPRESENTATIVE_OFFICE_LICENSE',
  ASSET_MANAGEMENT = 'ASSET_MANAGEMENT',

  // Insurance Licenses
  GENERAL_INSURANCE = 'GENERAL_INSURANCE',
  LONG_TERM_INSURANCE = 'LONG_TERM_INSURANCE',
  REINSURANCE = 'REINSURANCE',
  INSURANCE_BROKER = 'INSURANCE_BROKER',
  INSURANCE_AGENCY = 'INSURANCE_AGENCY',

  // Capital Markets Licenses
  DEALER_BROKER = 'DEALER_BROKER',
  INVESTMENT_ADVISOR = 'INVESTMENT_ADVISOR',
  STOCK_EXCHANGE = 'STOCK_EXCHANGE',
  CRYPTO_EXCHANGE = 'CRYPTO_EXCHANGE',
  CENTRAL_SECURITIES_DEPOSITORY = 'CENTRAL_SECURITIES_DEPOSITORY',
  CLEARING_HOUSE = 'CLEARING_HOUSE',
  CIS= 'CIS',
  CIS_FUND_MANAGER = 'CIS_FUND_MANAGER',
  CIS_TRUSTEE = 'CIS_TRUSTEE',
  CREDIT_RATING_AGENCY = 'CREDIT_RATING_AGENCY',
  CUSTODY_WALLET_SERVICES = 'CUSTODY_WALLET_SERVICES',
  CROWDFUNDING_PLATFORM = 'CROWDFUNDING_PLATFORM',

  //Ancillary Licenses
  LEGAL_SERVICES_FIRM = 'LEGAL_SERVICES_FIRM',
  ACCOUNTING_FIRM = 'ACCOUNTING_FIRM',
  AUDITING_FIRM = 'AUDITING_FIRM',
  CORPORATE_SERVICE_FIRM = 'CORPORATE_SERVICE_FIRM',
  BUSINESS_CONSULTING_FIRM = 'BUSINESS_CONSULTING_FIRM',
  COMPANY_FORMATION_AGENT = 'COMPANY_FORMATION_AGENT',

  //FINTECH:
  SANDBOX = 'SANDBOX',
  FULL_CUSTODIAL = 'FULL_CUSTODIAL',
  FULL_NON_CUSTODIAL = 'FULL_NON_CUSTODIAL',
  TOKEN_ISSUANCE = 'TOKEN_ISSUANCE',
  PAYMENT_SERVICES_PROVIDER = 'PAYMENT_SERVICES_PROVIDER',
  DIGITAL_ASSET_SERVICE_PROVIDER = 'DIGITAL_ASSET_SERVICE_PROVIDER',

  //GAMING:
  LOTTO = 'LOTTO',
  ECASINO = 'ECASINO',
  SPORTS_BETTING = 'SPORTS_BETTING',

  //Prrovisional
  PROVISIONAL_LICENCE = 'PROVISIONAL_LICENCE'
}
